import axiosInstance from './axiosInstance';

export const getManagerAssignments = () =>
    axiosInstance.get('/ManagerAssignment').then(r => r.data);

export const createManagerAssignment = (body) =>
    axiosInstance.post('/ManagerAssignment', body).then(r => r.data);

export const expireManagerAssignment = (id, effectiveTo) =>
    axiosInstance.post(`/ManagerAssignment/${id}/expire`, { effectiveTo }).then(r => r.data);
